import { render, staticRenderFns } from "./orderVerification.vue?vue&type=template&id=15f627f4&scoped=true&"
import script from "./orderVerification.vue?vue&type=script&lang=js&"
export * from "./orderVerification.vue?vue&type=script&lang=js&"
import style0 from "./orderVerification.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderVerification.vue?vue&type=style&index=1&id=15f627f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f627f4",
  null
  
)

export default component.exports